import(/* webpackMode: "eager", webpackExports: ["SimulatePreloadedQuery"] */ "/mom-baby-web/node_modules/@apollo/client-react-streaming/dist/index.cc.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/mom-baby-web/src/components/PageHome/index.tsx");
